import * as yup from "yup";

export const stnIdSchema= yup.object().shape({
  StnId: yup.number().required("stnId is required").typeError("stnId must be a number"),
});